import React, { useEffect, useState } from "react";

import { Layout, TextField } from "@shopify/polaris";

import { useAdmin } from "context/admin";

// Per-store allowlist of POS SUB DEPARTMENT NAMEs whose weighted items keep
// syncing PRICE while the global "skip weighted updates" safeguard is ON, without
// ever rebuilding their Sold-by weight/unit option. Empty = nothing syncs (the
// byte-for-byte unchanged default). Mirrors NotificationsSettings' auto-save TextField.
export default function ProduceSyncSettings({ shop_config }) {
  const admin = useAdmin();
  const [saving, setSaving] = useState(false);
  const [text, setText] = useState(
    (shop_config.globepos_weighted_sync_departments || []).join(", ")
  );

  useEffect(() => {
    setText((shop_config.globepos_weighted_sync_departments || []).join(", "));
  }, [shop_config]);

  // The allowlist is only meaningful while weight-based updates are globally
  // skipped — it is the exception list to that safeguard. Hide it otherwise so it
  // never confuses non-POS stores.
  if (!shop_config.globepos_skip_weighted_items) return null;

  const handleSave = (value) => {
    const departments = value
      .split(",")
      .map((part) => part.trim())
      .filter((part) => part.length > 0);
    setSaving(true);
    admin
      .updateShopConfig({ globepos_weighted_sync_departments: departments })
      .finally(() => setSaving(false));
  };

  return (
    <Layout.AnnotatedSection
      title="Produce price sync (weighted allowlist)"
      description={
        <p>
          Weight-based updates are currently skipped. Items in these POS{" "}
          <strong>SUB DEPARTMENT NAME</strong>s still sync price on import, and
          their Sold-by weight option is never rebuilt. Use this to keep produce
          prices current without touching deli, meat, seafood or bulk weighed
          items.
        </p>
      }
    >
      <TextField
        label="Sync price for these departments"
        value={text}
        onChange={setText}
        onBlur={(event) => handleSave(event.target.value)}
        helpText={
          'Comma-separated SUB DEPARTMENT NAMEs, e.g. "PRODUCE". ' +
          "Case-insensitive. Leave blank to sync nothing."
        }
        disabled={saving}
        autoComplete="off"
      />
    </Layout.AnnotatedSection>
  );
}
